"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveOpeningEvent = exports.updateBid = exports.createBid = void 0;
const fp = require("fp-ts");
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ActionTypes = require("../../actionTypes/bid/basicInformation");
const Actions = require("../../actions/bid/basicInformation");
const bid_1 = require("../../actions/bid");
const FilesActions = require("../../actions/files");
const validation_1 = require("../../utils/validation");
const translation_1 = require("../../utils/translation");
const sok_types_1 = require("@caddigital/sok-types");
const errorHandling_1 = require("../../utils/errorHandling");
function validateProcurements(params, validation, validations) {
    for (let i = 0; i < validations.length; i++) {
        const x = validations[i];
        if (params[x.checkbox]) {
            for (let j = 0; j < x.dateFields.length; j++) {
                const field = x.dateFields[j];
                validation = (0, validation_1.ap)((0, validation_1.isNotNull)(`procurement-${field}`)(params[field]))(validation);
            }
        }
    }
    return validation;
}
const procurementValidations = [
    { checkbox: 'preQualification', dateFields: ['preQualificationDeadline'] },
    { checkbox: 'negotitation', dateFields: ['negotitationEndAt'] },
    {
        checkbox: 'suitabilityAndFinancialProposals',
        dateFields: []
    },
    {
        checkbox: 'questionsAndAnswers',
        dateFields: [
            'questionsAndAnswersDeadline',
            'questionsAndAnswersPublishedAt'
        ]
    }
];
function validateProjectBillingInformation(params) {
    return (validation) => {
        if (params.billingInformation &&
            params.billingInformation.type === 'INTERNAL' &&
            params.billingInformation.projects &&
            params.billingInformation.projects.length > 0) {
            validation = (0, validation_1.ap)((0, validation_1.isNotUndefined)('selectedProject')(params.billingInformation.selectedProject))(validation);
        }
        return validation;
    };
}
function validatePrints(params) {
    return (validation) => {
        if (params.provideCopies > 0 || params.billingInformation) {
            validation = fp.function.compose((0, validation_1.ap)((0, validation_1.isNotUndefined)('billingInformation')(params.billingInformation)), (0, validation_1.ap)((0, validation_1.isNotNull)('billingInformation')(params.billingInformation)))(validation);
            if (params.provideCopies &&
                params.provideCopies > 0 &&
                params.billingInformation &&
                params.billingInformation.type === 'CUSTOM') {
                validation = fp.function.compose((0, validation_1.ap)((0, validation_1.isNotEmpty)('customerName')(params.billingInformation)), (0, validation_1.ap)((0, validation_1.isNotEmpty)('streetAddress')(params.billingInformation)), (0, validation_1.ap)((0, validation_1.isNotEmpty)('postalCode')(params.billingInformation)), (0, validation_1.ap)((0, validation_1.isNotEmpty)('city')(params.billingInformation)))(validation);
            }
            if (params.billingInformation &&
                params.billingInformation.type === 'INTERNAL' &&
                params.billingInformation.projects &&
                params.billingInformation.projects.length > 0) {
                validation = (0, validation_1.ap)((0, validation_1.isNotUndefined)('selectedProject')(params.billingInformation.selectedProject))(validation);
            }
        }
        return validation;
    };
}
function validateDates(params, validation) {
    if (params.bidType === 'BID' &&
        params.startAt !== null &&
        params.endAt !== null) {
        if (params.startAt > params.endAt) {
            validation = (0, validation_1.ap)(fp.validation.failure([
                {
                    key: 'endAt',
                    value: (0, translation_1.getLocalization)('bid/basicInformation/invalidEndAt')
                }
            ]))(validation);
        }
        if (params.currentBid && params.currentBid.procerement.openingEventAt) {
            if (params.endAt > params.currentBid.procerement.openingEventAt) {
                validation = (0, validation_1.ap)(fp.validation.failure([
                    {
                        key: 'endAt',
                        value: (0, translation_1.getLocalization)('bid/basicInformation/invalidEndAtOpeningDate')
                    }
                ]))(validation);
            }
            if (params.startAt > params.currentBid.procerement.openingEventAt) {
                validation = (0, validation_1.ap)(fp.validation.failure([
                    {
                        key: 'endAt',
                        value: (0, translation_1.getLocalization)('bid/basicInformation/invalidStartAtOpeningDate')
                    }
                ]))(validation);
            }
        }
        return validation;
    }
    return validation;
}
const validateSave = (params) => {
    let v = fp.validation.success(true);
    v = (0, validation_1.isNotEmpty)('name', 'basic-name')(params);
    if (params.publish ||
        (((params.currentBid && params.currentBid.status === 'BID') ||
            (params.currentBid && params.currentBid.status === 'ADDENDUMS')) &&
            params.printOrders &&
            params.printOrders.provideCopies > 0)) {
        v = validatePrints(params.printOrders)(v);
    }
    if (params.printOrders &&
        params.printOrders.provideCopies > 0 &&
        params.printOrders.billingInformation) {
        v = validateProjectBillingInformation(params.printOrders)(v);
    }
    if (params.bidType === 'ADDITIONAL') {
        return v;
    }
    v = validateDates(params, v);
    v = validateProcurements(params.procerement, v, procurementValidations);
    if (params.publish) {
        v = fp.function.compose((0, validation_1.ap)((0, validation_1.isNotEmpty)('company', 'buyer-company')(params.buyer)), (0, validation_1.ap)((0, validation_1.isNotNull)('startAt')(params.startAt)), (0, validation_1.ap)((0, validation_1.isNotNull)('endAt')(params.endAt)), (val) => {
            (0, validation_1.ap)((0, validation_1.isNotNull)('startAt')(params.startAt));
            if (params.procerement.openingEvent) {
                return (0, validation_1.ap)((0, validation_1.isNotNull)('procurement-openingEventAt')(params.procerement.openingEventAt))(val);
            }
            return val;
        }, (val) => {
            if (params.currentBid &&
                params.procerement.openingEvent &&
                params.procerement.openingEventAt !== null &&
                params.procerement.openingEventAt !==
                    params.currentBid.procerement.openingEventAt) {
                return (0, validation_1.ap)(fp.validation.failure([
                    {
                        key: 'procurement-openingEventAt',
                        value: (0, translation_1.getLocalization)('bid/validation/openingEvent/notSaved')
                    }
                ]))(val);
            }
            return val;
        })(v);
    }
    return v;
};
function createBid(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.CREATE_REQUEST), (0, operators_1.mergeMap)((action) => validateSave(Object.assign(Object.assign({}, action.payload.body), { bidType: action.payload.type })).fold((x) => (0, rxjs_1.of)(Actions.createValidation(x)), () => {
        return ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            body: action.payload.body,
            url: `${baseUrl}api/briefcase/${action.payload.briefcase.id}/bid${action.payload.type === 'ADDITIONAL'
                ? `/${action.payload.bidId}/letter`
                : ''}`
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            const validation = t
                .intersection([
                t.interface({
                    path: t.array(sok_types_1.File.iFolder),
                    bid: sok_types_1.Bid.iBid
                }),
                t.partial({
                    documents: sok_types_1.File.iFolder,
                    attachments: sok_types_1.File.iFolder,
                    questions: sok_types_1.File.iFolder
                })
            ])
                .decode(xhr.response);
            return validation.fold((error) => {
                return (0, rxjs_1.of)(Actions.createFailed((0, errorHandling_1.parseValidationError)(error))).pipe((0, operators_1.delay)(100));
            }, (res) => {
                return (0, rxjs_1.of)((action.payload.type === 'ADDITIONAL'
                    ? bid_1.CurrentAddendums
                    : bid_1.CurrentBid).fetchSuccess(res.bid, res.path, 0, [], res.documents, res.attachments, res.questions), Actions.createSuccess(res.bid));
            });
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.createFailed((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    })));
}
exports.createBid = createBid;
const checkBidFiles = (ajax, getToken, bid, baseUrl, publish) => {
    if (!publish) {
        return (0, rxjs_1.of)({
            response: { files: 0, isVastuuApiIdentifierMissing: false }
        });
    }
    return ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'GET',
        url: `${baseUrl}api/bid/${bid && bid.id}/validate`
    });
};
function updateBid(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.UPDATE_REQUEST), (0, operators_1.mergeMap)((action) => {
        const publish = action.payload.publish;
        const curr = store.value.bid;
        let current = store.value.bid.current;
        if (action.payload.type === 'ADDITIONAL') {
            current = store.value.bid.currentAddendum;
        }
        return checkBidFiles(ajax, getToken, current.bid, baseUrl, publish).pipe((0, operators_1.mergeMap)(({ response }) => {
            let val = validateSave(Object.assign(Object.assign({ bidType: action.payload.type }, action.payload.body), { publish: publish, currentBid: curr.current.bid }));
            const errors = [];
            if (publish && response) {
                if (response.files === 0) {
                    errors.push({
                        key: 'files',
                        value: (0, translation_1.getLocalization)('validation/error/atLeastOneFile')
                    });
                }
                if (response.isVastuuApiIdentifierMissing) {
                    errors.push({
                        key: 'vastuuApiIdentifier',
                        value: (0, translation_1.getLocalization)('validation/error/vastuuApiIdentifier')
                    });
                }
            }
            if (errors.length > 0) {
                val = (0, validation_1.ap)(fp.validation.failure(errors))(val);
            }
            return val.fold((validation) => (0, rxjs_1.of)(Actions.updateValidation({ validation, publish })), () => ajax({
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: getToken()
                },
                method: 'PUT',
                body: action.payload.body,
                url: `${baseUrl}api/briefcase/${action.payload.briefcase.id}/bid/${action.payload.bid.id}${publish ? `?publish=true` : ''}`
            }).pipe((0, operators_1.mergeMap)((xhr) => {
                return sok_types_1.Bid.iBid
                    .decode(xhr.response)
                    .fold((error) => (0, rxjs_1.of)(Actions.updateFailed((0, errorHandling_1.parseValidationError)(error))), (bid) => {
                    const { files: { sortByOptions, searchOptions } } = store.value;
                    const actions = [
                        Actions.updateSuccess(bid),
                        (action.payload.type === 'ADDITIONAL'
                            ? bid_1.CurrentAddendums
                            : bid_1.CurrentBid).fetchSuccess(bid, current.path, 0, [], current.documents, current.attachments, current.questions)
                    ];
                    if (current.documents) {
                        actions.push(FilesActions.fetchFiles(current.documents.id, sortByOptions, searchOptions));
                    }
                    return (0, rxjs_1.of)(...actions);
                });
            }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.updateFailed((0, errorHandling_1.parseAjaxErrorResponse)(error))))));
        }));
    }));
}
exports.updateBid = updateBid;
function saveOpeningEvent(action$, store, { ajax, getToken, baseUrl }) {
    return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.SAVE_OPENING_EVENT_REQUEST), (0, operators_1.mergeMap)((action) => {
        if (action.payload.bid.status.includes('ADDENDUMS')) {
            return (0, rxjs_1.of)(Actions.saveOpeningFailed({ type: 'UNKNOWN_ERROR', raw: {} }));
        }
        let validation = fp.validation.success(true);
        if ((action.payload.bid.procerement.openingEventAt || 0) >
            (action.payload.body.procerement.openingEventAt || 0)) {
            validation = (0, validation_1.ap)(fp.validation.failure([
                {
                    key: 'openingEventAt',
                    value: (0, translation_1.getLocalization)('bid/validation/openingEvent/cannotBeBefore')
                }
            ]))(validation);
        }
        validation = (0, validation_1.ap)((0, validation_1.isNotNull)('procurement-openingEventAt')(action.payload.body.procerement['openingEventAt']))(validation);
        const procerement = action.payload.body.procerement
            ? action.payload.body.procerement
            : null;
        const current = store.value.bid.current.bid
            ? store.value.bid.current.bid
            : null;
        const bidEntAt = action.payload.body.endAt;
        if ((current &&
            current.endAt &&
            procerement &&
            procerement.openingEventAt &&
            current.endAt > procerement.openingEventAt) ||
            (procerement &&
                procerement.openingEventAt &&
                bidEntAt &&
                bidEntAt > procerement.openingEventAt)) {
            validation = (0, validation_1.ap)(fp.validation.failure([
                {
                    key: 'openingEventAt',
                    value: (0, translation_1.getLocalization)('bid/validation/openingEvent/cannotBeBefore')
                }
            ]))(validation);
        }
        if (current &&
            current.endAt &&
            procerement &&
            procerement.openingEventAt &&
            current.endAt >= procerement.openingEventAt) {
            validation = (0, validation_1.ap)(fp.validation.failure([
                {
                    key: 'openingEventAt',
                    value: (0, translation_1.getLocalization)('bid/validation/openingEvent/cannotBeSame')
                }
            ]))(validation);
        }
        return validation.fold((errors) => (0, rxjs_1.of)(Actions.saveOpeningValidation(errors)), () => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'PUT',
            body: action.payload.body,
            url: `${baseUrl}api/briefcase/${action.payload.briefcase.id}/bid/${action.payload.bid.id}/opening-event`
        }).pipe((0, operators_1.mergeMap)((xhr) => {
            return sok_types_1.Bid.iBid
                .decode(xhr.response)
                .fold((error) => (0, rxjs_1.of)(Actions.saveOpeningFailed((0, errorHandling_1.parseValidationError)(error))), () => {
                const current = store.value.bid.current;
                if (!current.bid) {
                    return (0, rxjs_1.empty)();
                }
                return (0, rxjs_1.of)(Actions.saveOpeningSuccess(), bid_1.CurrentBid.fetchSuccess(Object.assign(Object.assign({}, current.bid), { procerement: Object.assign(Object.assign({}, current.bid.procerement), { openingEventAt: action.payload.body.procerement.openingEventAt }) }), current.path, 0, [], current.documents, current.attachments, current.questions));
            });
        }), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.saveOpeningFailed((0, errorHandling_1.parseAjaxErrorResponse)(error))))));
    }));
}
exports.saveOpeningEvent = saveOpeningEvent;
//# sourceMappingURL=basicInformation.js.map